import React from "react";
import Hero from "./Hero";
import About from "./About";
import Skills from "./Skills";
import Experiences from "./Experiences";
import Contact from "./Contact";

function Home() {
  return (
    <>
      <Hero />
      <About />
      <Skills />
      <Experiences />
      <Contact />
    </>
  );
}

export default Home;
